<template>
  <div>
    <component
      v-for="subItem in permissionItem.subItems"
      :is="switchComponent(subItem.type)"
      :key="subItem.title"
      :tab-name="permissionItem.name"
      :sub-item="subItem"
      :disabled="subItem.disabled"
      :is-opened="isOpened(subItem.relatedPermissions)"
      :is-scoped="isScoped(subItem.relatedPermissions)"
      :role-permissions="rolePermissions"
      :has-errors="hasErrors(permissionItem.name, subItem.name)"
      @switch-change="$emit('update-role-permissions', $event)"
      @checkbox-change="$emit('check-role-permissions', $event)"
    />
  </div>
</template>

<script>
import RoleDrawerSimpleSwitch from './RoleDrawerSimpleSwitch';
import RoleDrawerScopedSwitch from './RoleDrawerScopedSwitch';

export default {
  name: 'role-drawer-knowledge-base-tab',
  components: {
    RoleDrawerSimpleSwitch,
    RoleDrawerScopedSwitch,
  },
  props: {
    rolePermissions: {
      type: Array,
      default: () => [],
    },
    permissionItem: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    switchComponent(type) {
      return `RoleDrawer${type || 'Simple'}Switch`;
    },
    isOpened(relatedPermissions) {
      return this.rolePermissions.some((permission) =>
        relatedPermissions.includes(permission.rolePermission),
      );
    },
    isScoped(relatedPermissions) {
      return this.rolePermissions.some(
        ({ rolePermission, scope }) =>
          relatedPermissions.includes(rolePermission) &&
          this.isScopeDefined(scope, ['knowledgeIds']),
      );
    },
    isScopeDefined(scope, keysToCheck) {
      if (!scope) return false;

      return keysToCheck.some((key) => scope[key] && scope[key].length);
    },
    hasErrors(tabName, switchName) {
      return this.errors[tabName] && this.errors[tabName][switchName];
    },
  },
};
</script>

<style lang="scss" scoped></style>
